export enum FileTypes {
    MOR = 1,
    MAO = 2
}
